// src/components/Navbar.js
import React from 'react';
import { Navbar, Container, Nav } from 'react-bootstrap';
import '../css/Navbar.css'; // Make sure to style it accordingly

const NavigationBar = ({ playerData }) => {
  return (
    <Navbar bg="light" expand="lg" className="">
      <Container>
        <Navbar.Brand href="#home">
          <a href='https://eduplayzone.in/'>
          <img
            src="https://eduplayzone.in/image/eduplayzone_logo_new.png" // Replace with the actual path to your logo image
            width="30"
            height="30"
            className="d-inline-block align-top ml-2"
            alt="Quiz Zone Logo"
          /></a>
          {' '}
          <h5 className='logo-text'>Quiz-Zone</h5>
        </Navbar.Brand>
        <Nav className="ml-auto">
          <Nav.Item className="d-flex align-items-center">
            <span className="ml-2">{playerData.name}</span>
            {' '}
            <img
              src={playerData.avatar} // Replace with actual paths
              width="30"
              height="30"
              className="d-inline-block align-top rounded-circle"
              alt="Player Avatar"
            />
          </Nav.Item>
        </Nav>
      </Container>
    </Navbar>
  );
};

export default NavigationBar;
